import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Link } from 'react-router-dom';
import {
  makeStyles,
  Drawer,
  Card,
  CardContent,
  Typography,
  CardHeader,
  Divider,
  Box,
  CardActions,
  Button,
  Paper,
  ListItem,
  ListItemText,
  IconButton
} from '@material-ui/core';
import { CreditCard as BuyCreditIcon } from 'react-feather';
import {
  Dialpad as DialpadIcon,
  DialerSip as DialerSipIcon,
  ArrowBack as BackIcon,
  Search as SearchIcon,
  Minimize as CloseIcon
} from '@material-ui/icons';
import FAQSCategories from './catagories';
import FAQSQuestion from './questions';


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#fff'
  },
  card: {
    width: 400,
    display: 'flex',
    flexDirection: 'column',
    '&.MuiPaper-outlined': {
      border: 'none'
    },
    '& .MuiCardHeader-avatar': {
      marginRight: '4px'
    }
  },
  cardHeader: {
    backgroundColor: '#00609A',
    color: '#fff'
  },
  title: {
    fontSize: 14,
    color: '#fff'
  },
  rightDrawer: {
    '& .MuiDrawer-paperAnchorRight': {
      top: '129px',
      height: 'calc(100% - 129px)',
      borderRadius: '5px'
    }
  },
  question: {
    color: '#1a3d5d',
    fontWeight: '700',
    marginBottom: '10px',
    fontSize: '15px',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  divider: {
    marginBottom: '20px'
  },
  cardContent: {
    flexGrow: 1
  },
  questionHead: {
    color: '#57584e',
    fontSize: '22px'
  },
  img: {
    width: '100%'
  },
  imgBox: {
    width: '400px'
  },
  staticBox: {
    height: '60px',
    width: '100%'
    // backgroundColor:'blue',
    // position:'static'
  },
  searchBox: {
    width: '100%',
    height: '90%',
    border: '0',
    padding: '10px 15px',
    outline: '0',
    fontSize: '14px',
    color: '#555'
  },
  formGroup: {
    display: 'flex',
    paddingTop: '10px'
  },
  searchIcon: {
    paddingTop: '10px',
    paddingRight: '10px',
    cursor: 'pointer'
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  headerBox: {
    margin: '15px 0px '
  }
}));

let faqCategories = [
  {
    id: 1,
    type: 'Fund Wallet',
    icon: BuyCreditIcon
  },
  {
    id: 2,
    type: 'SIP Account',
    icon: DialerSipIcon
  },
  {
    id: 3,
    type: 'Vezeti Number',
    icon: DialpadIcon
  }
  // {
  //   id: 4,
  //   type: 'Fund Wallet'
  // },
  // {
  //   id: 5,
  //   type: 'Fund Wallet'
  // }
];

let faqAnswers = [
  {
    id: 1,
    question: 'How do I setup my account',
    answer: `The Min/Max Order Limit feature lets you control how many units of a product a customer can buy at a time.
        To set a min/max order limit for a product which doesn't have variants, kindly follow these steps:`
  },
  {
    id: 2,
    question: 'How can I buy credit',
    answer: `The Min/Max Order Limit feature lets you control how many units of a product a customer can buy at a time.
        To set a min/max order limit for a product which doesn't have variants, kindly follow these steps:`
  },
  {
    id: 3,
    question: 'How can I add more SIP Account',
    answer: `The Min/Max Order Limit feature lets you control how many units of a product a customer can buy at a time.
        To set a min/max order limit for a product which doesn't have variants, kindly follow these steps:`
  },
  {
    id: 4,
    question: 'How can I download my call history',
    answer: `The Min/Max Order Limit feature lets you control how many units of a product a customer can buy at a time.
        To set a min/max order limit for a product which doesn't have variants, kindly follow these steps:`
  },
  {
    id: 5,
    question: 'How can I download my call history',
    answer: `The Min/Max Order Limit feature lets you control how many units of a product a customer can buy at a time.
        To set a min/max order limit for a product which doesn't have variants, kindly follow these steps:`
  }
];
const FAQS = ({ onClose, open }) => {
  const classes = useStyles();
  const [openAns, setOpenAnswer] = useState('category');

  const handleGoQuestion = () => {
    setOpenAnswer('questions');
  };
  const handleAnswer = () => {
    setOpenAnswer('answers');
  };
  
  return (
    <div>
      {/* onClick={onClose} */}
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        className={classes.rightDrawer}
      >
        <Card className={classes.card} variant="outlined">
          {openAns == 'category' && (
            <CardHeader
              className={classes.cardHeader}
              title="Choose Category"
              titleTypographyProps={{ variant: 'body1' }}
              action={
                <IconButton
                  aria-label="close"
                  size="small"
                  color="inherit"
                  onClick={onClose}
                >
                  <CloseIcon />
                </IconButton>
              }
            />
          )}
          {openAns == 'questions' && (
            <CardHeader
              onClick={() => setOpenAnswer('category')}
              className={classes.cardHeader}
              avatar={<BackIcon />}
              title="Back to categories"
              action={
                <IconButton
                  aria-label="close"
                  size="small"
                  color="inherit"
                  size="small"
                  onClick={onClose}
                >
                  <CloseIcon />
                </IconButton>
              }
            />
          )}
          {openAns == 'answers' && (
            <CardHeader
              onClick={() => setOpenAnswer('questions')}
              className={classes.cardHeader}
              avatar={<BackIcon />}
              title="Back to questions"
              action={
                <IconButton
                  aria-label="close"
                  
                  size="small"
                  color="inherit"
                  size="small"
                  onClick={onClose}
                >
                  <CloseIcon />
                </IconButton>
              }
            />
          )}

          <PerfectScrollbar>
            {openAns == 'category' && (
              <CardContent className={classes.cardContent}>
                {faqCategories.map((question) => (
                  <FAQSCategories
                    key={question.id}
                    question={question}
                    handleGoQuestion={handleGoQuestion}
                  />
                ))}
              </CardContent>
            )}
            {openAns == 'questions' && (
              <CardContent className={classes.cardContent}>
                {faqAnswers.map((question) => (
                  <FAQSQuestion
                    key={question.id}
                    question={question}
                    handleAnswer={handleAnswer}
                  />
                ))}
              </CardContent>
            )}
            {openAns == 'answers' && (
              <CardContent className={classes.cardContent}>
                <Typography
                  className={classes.questionHead}
                  color="textSecondary"
                  gutterBottom
                >
                  How do I set my account
                </Typography>
                <Typography
                  // className={classes.question}
                  color="textSecondary"
                  gutterBottom
                >
                  The Min/Max Order Limit feature lets you control how many
                  units of a product a customer can buy at a time. To set a
                  min/max order limit for a product which doesn't have variants,
                  kindly follow these steps:
                </Typography>
                <Box mb={1}>1. Log in to the Vezeti Dashboard</Box>
                <Box mb={1}>
                  2. Click on <Link>SIP Account</Link> on the left side menu
                </Box>
                <Box mb={1}>
                  2. Click on <Link>Add SIP Account</Link>
                </Box>
                <Box mb={1} mt={2} className={classes.imgBox}>
                  <img
                    src="/static/sip-account.png"
                    alt="Buy Credit"
                    className={classes.img}
                  />
                </Box>
              </CardContent>
            )}

            {openAns == 'questions' && (
              <Box className={classes.btnContainer}>
                <Button variant="contained">Load more articles</Button>
              </Box>
            )}
          </PerfectScrollbar>
          {openAns == 'questions' && (
            <CardActions>
              <Box className={classes.staticBox} flexGrow={1}>
                <Divider />
                <Box className={classes.formGroup}>
                  <input
                    type=""
                    placeholder="What can we help you with"
                    name="searchBox"
                    className={classes.searchBox}
                  />
                  <div className={classes.searchIcon}>
                    <SearchIcon />
                  </div>
                </Box>
              </Box>
            </CardActions>
          )}
        </Card>
      </Drawer>
    </div>
  );
};

FAQS.propTypes = {
  onApply: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired
};

FAQS.defaultProps = {
  onApply: () => {},
  onClose: () => {}
};
export default FAQS;
